import { useQuery, type UseQueryOptions } from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import type { DonationDto, QueryParamsDto, ResponseDto } from "@mimber/schema"
import { donationsKeys } from "../donations.utils"

export const useDonations = (
  params?: QueryParamsDto,
  options?: UseQueryOptions<ResponseDto<DonationDto[]>, Error>
) => {
  guardAppUsage("mimber-organization", "useDonations")

  const { server } = useServerContext()

  return useQuery<ResponseDto<DonationDto[]>, Error>({
    queryKey: donationsKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<ResponseDto<DonationDto[]>>(
        buildQueryString("donations", params)
      )
      return response.data
    },
    ...options,
  })
}
